module.exports = __webpack_public_path__ + "img/hanyue_p.9d43da98.png";